import React from "react"
import { Link } from "gatsby"

const Clickable = ({ href, to, div, ...props }) => {
  if (href) {
    return <a href={href} target="_blank" {...props} />
  } else if (to) {
    return <Link to={to} {...props} />
  } else if (div) {
    return <div role="button" tabIndex={0} {...props} />
  }
  return <a role="button" tabIndex={0} {...props} />
}

export default Clickable
